import { render, staticRenderFns } from "./wx-charge.vue?vue&type=template&id=5bef1db6&scoped=true&"
import script from "./wx-charge.vue?vue&type=script&lang=js&"
export * from "./wx-charge.vue?vue&type=script&lang=js&"
import style0 from "./wx-charge.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./wx-charge.vue?vue&type=style&index=1&id=5bef1db6&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bef1db6",
  null
  
)

export default component.exports